function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgReplyAll = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.176,
    height: 8.534,
    viewBox: "0 0 12.176 8.534",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.6 17.193 4 13.6 7.6 10l.655.655L5.311 13.6l2.941 2.941zm7.665 1.341v-2.378a2.033 2.033 0 0 0-2.1-2.1H8.511l2.484 2.484-.655.655-3.6-3.6 3.6-3.6.655.655-2.484 2.489h4.648a2.943 2.943 0 0 1 3.017 3.017v2.377z",
    transform: "translate(-4 -10)",
    style: {
      fill: "#3953fb"
    }
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplyAll, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replyAll.36275ebc.svg";
export { ForwardRef as ReactComponent };